(function() {

  function newsTabSwitch() {
    $('.news__item').click(function() {
      $('.news__box').hide();
      $('#' + $(this).data('box')).show();
      $('.news__item').removeClass('is-current');
      $(this).addClass('is-current');
    })
  }

  function renderNews() {
    $.ajax({
      url: '/upload/news/list.json',
      dataType: 'json'
    })
      .then(
        function (data) {
          $('#box-1').find('.news__list').html(getNewsHtml(data['news']));
          $('#box-2').find('.news__list').html(getNewsHtml(data['press-release']));
        },
        function () {}
      );
  }

  function getNewsHtml(data) {
    let newsHtml = '';
    $.each(data, function(index, value) {
      newsHtml += '<li class="news__list-item">';
      newsHtml += '<a href="/news/' + value.id +'/" class="news__link">';
      newsHtml += '<img src="/assets/img/common/orange-icon.svg" alt="" class="news__icon" />';
      newsHtml += '<p class="news__data">' + value.date +'</p>';
      newsHtml += '<p class="news__text">' + value.title +'</p>';
      newsHtml += '</a>';
      newsHtml += '</li>';
    })

    return newsHtml;
  }

  const isNewsPage = $('.news-page').length;
  if(isNewsPage) {
    newsTabSwitch();
    renderNews();
  }
})();